module.exports = __webpack_public_path__ + "img/icon-excel_b.c3afdf11.svg";